import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button, Chip, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icon, BackdropLoader } from '@livable/saas-react-components';
import { BigInfoAlert, BigSuccessAlert, BigErrorAlert } from 'src/components/general/BigAlerts';
import useStyles from './styles';
export const EditForm = observer(_ref => {
  let status = _ref.status,
    handleModalStates = _ref.handleModalStates,
    handleModalClose = _ref.handleModalClose;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const BigStatusAlert = _ref2 => {
    let alertStatus = _ref2.alertStatus;
    switch (alertStatus) {
      case 'error':
        return /*#__PURE__*/React.createElement(BigErrorAlert, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, t('add_new_property_flow.auto_billing_edit_error_alert')));
      case 'success':
        return /*#__PURE__*/React.createElement(BigSuccessAlert, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, t('add_new_property_flow.auto_billing_edit_success_alert')));
      case 'canceled':
        return /*#__PURE__*/React.createElement(BigInfoAlert, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, t('add_new_property_flow.auto_billing_edit_canceled_alert')));
      case 'pending':
        return /*#__PURE__*/React.createElement(BigInfoAlert, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5"
        }, t('add_new_property_flow.auto_billing_edit_pending_alert')));
    }
  };
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowHiddenPassword = _useState2[0],
    setIsShowHiddenPassword = _useState2[1];
  const _useState3 = useState('pending'),
    _useState4 = _slicedToArray(_useState3, 2),
    statusInternal = _useState4[0],
    setStatusInternal = _useState4[1]; // NOTE: info | success | error

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BigStatusAlert, {
    alertStatus: statusInternal || status || 'info'
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.createFormContainer)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.auto_billing_details_preview')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.detailsPreviewRow)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.detailsPreviewTitle),
    color: 'light',
    component: 'span'
  }, t('add_new_property_flow.auto_billing_user_name')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.detailsPreviewValue),
    component: 'span'
  }, 'Tom Croissant')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.detailsPreviewRow)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.detailsPreviewTitle),
    color: 'light',
    component: 'span'
  }, t('general.password')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: 'div'
  }, isShowHiddenPassword ? 'Password 123123' : '••••••••••••', /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.detailsPreviewShowProtectedData),
    onClick: () => {
      if (!isShowHiddenPassword) setTimeout(() => {
        setIsShowHiddenPassword(false);
      }, 10000);
      setIsShowHiddenPassword(!isShowHiddenPassword);
    }
  }, !isShowHiddenPassword ? /*#__PURE__*/React.createElement(Icon, {
    type: "show-eye-on",
    state: 'grey'
  }) : /*#__PURE__*/React.createElement(Icon, {
    type: "show-eye-off",
    state: 'grey'
  })))), [{
    questionName: 'What was your favorite school teacher’s name?',
    answerName: 'Answear blabla'
  }, {
    questionName: 'What was your favorite school teacher’s name @?',
    answerName: 'Answear2 blabla'
  }].map((questionGroup, index) => {
    const _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isShowHidden = _useState6[0],
      setIsShowHidden = _useState6[1];
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.detailsPreviewRow),
      key: index
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: "".concat(classes.detailsPreviewTitle),
      color: 'light',
      component: 'span'
    }, t('add_new_property_flow.auto_billing_security_question_number', {
      number: index + 1
    })), /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.detailsPreviewValue)
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      component: 'div',
      color: 'light'
    }, questionGroup === null || questionGroup === void 0 ? void 0 : questionGroup.questionName), ' ', /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      component: 'div'
    }, t('general.answer'), ': ', isShowHidden ? questionGroup.answerName : '••••••••••••', /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.detailsPreviewShowProtectedData),
      onClick: () => {
        if (!isShowHidden) setTimeout(() => {
          setIsShowHidden(false);
        }, 10000);
        setIsShowHidden(!isShowHidden);
      }
    }, !isShowHidden ? /*#__PURE__*/React.createElement(Icon, {
      type: "show-eye-on",
      state: 'grey'
    }) : /*#__PURE__*/React.createElement(Icon, {
      type: "show-eye-off",
      state: 'grey'
    })))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.detailsPreviewRow)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.detailsPreviewTitle),
    color: 'light',
    component: 'span'
  }, t('add_new_property_flow.bill_frequency')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.detailsPreviewValue),
    component: 'span'
  }, 'Monthly')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.detailsPreviewRow)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.detailsPreviewTitle),
    color: 'light',
    component: 'span'
  }, t('add_new_property_flow.auto_billing_activation_status')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.detailsPreviewValue, " ").concat(classes.detailsPreviewStatusChip),
    component: 'span'
  }, /*#__PURE__*/React.createElement(Chip, {
    label: "Pending",
    variant: "inactive",
    onClick: () => setStatusInternal('pending')
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Canceled",
    variant: "inactive",
    onClick: () => setStatusInternal('canceled')
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Failed",
    variant: "critical",
    onClick: () => setStatusInternal('error')
  }), /*#__PURE__*/React.createElement(Chip, {
    label: "Success",
    variant: "success",
    onClick: () => setStatusInternal('success')
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.detailsPreviewRow, " ").concat(classes.detailsPreviewActions)
  }, /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classes.radioItemGeneralSpacing),
    variant: "actionIcon",
    onClick: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalStates && handleModalStates('create');
    },
    'custom-attribute': '632-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit",
    color: 'light'
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.auto_billing_edit_details_btn'))), /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classes.radioItemGeneralSpacing),
    variant: "actionIcon",
    onClick: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalStates && handleModalStates('create');
    },
    'custom-attribute': '633-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "error",
    color: 'light'
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.auto_billing_cancel_automation_btn'))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    state: "active",
    onClick: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalStates && handleModalStates('create');
    },
    'custom-attribute': '634-new-billing-module'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.auto_billing_provide_new_credentials_btn'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => {
      handleModalClose();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalStates && handleModalStates('create');
    },
    'custom-attribute': '635-new-billing-module'
  }, t('buttons.done'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: false
  }));
});